<template>
  <div class="mobileoverflow" style="width: 100%; margin-top: 30px;">
	  <table class="tablestyle">
      <thead>
        <tr>
          <th>{{ $t('result_page.draw_result_id') }}</th>
          <th>{{ $t('datetime') }}</th>
          <th class="info-td-o">P {{ $t('sum') }}</th>
          <th class="info-td-o">B {{ $t('sum') }}</th>
          <th class="info-td-o">PB {{ $t('sum') }}</th>
          <th class="info-td-o">PB</th>
          <th class="info-td-o">P {{ $t('B/S') }}</th>
          <th class="info-td-o">P {{ $t('O/E') }}</th>
          <th class="info-td-o">P {{ $t('R/B') }}</th>
          <th class="info-td-o">P {{ $t('H/L') }}</th>
          <th class="info-td-o">B {{ $t('B/S') }}</th>
          <th class="info-td-o">B {{ $t('O/E') }}</th>
          <th class="info-td-o">B {{ $t('R/B') }}</th>
          <th class="info-td-o">B {{ $t('H/L') }}</th>
          <th class="info-td-o">S {{ $t('B/S') }}</th>
          <th class="info-td-o">S {{ $t('O/E') }}</th>
          <th class="info-td-o">S {{ $t('R/B') }}</th>
          <th class="info-td-o">S {{ $t('H/L') }}</th>
      </tr>
	    </thead>
			<tbody>
        <Pass
          v-for="(column, index) in data"
          :key="index"
          :metadata="getDataDetail(column)"
        >
          <tr
            slot-scope="{ metadata }"
            v-if="metadata.resultRaw !== undefined"
          >
            <td>{{ column.id }}</td>
            <td>{{ column.endAt }}</td>
            <td class="info-td-o">{{ metadata.playerTotal }}</td>
            <td class="info-td-o">{{ metadata.bankerTotal }}</td>
            <td class="info-td-o">{{ metadata.resultRaw.mainTotal }}</td>
            <td class="info-td-o">
              <PlayerBanker :value="metadata.result" />
            </td>
            <td class="info-td-o"><BigSmall :value="metadata.playerBigSmall" /></td>
            <td class="info-td-o"><OddEven :value="metadata.playerOddEven" /></td>
            <td class="info-td-o"><RedBlack :value="metadata.playerRedBlack" /></td>
            <td class="info-td-o"><HighLow :value="metadata.playerHighLow" /></td>

            <td class="info-td-o"><BigSmall :value="metadata.bankerBigSmall" /></td>
            <td class="info-td-o"><OddEven :value="metadata.bankerOddEven" /></td>
            <td class="info-td-o"><RedBlack :value="metadata.bankerRedBlack" /></td>
            <td class="info-td-o"><HighLow :value="metadata.bankerHighLow" /></td>

            <td class="info-td-o"><BigSmall :value="metadata.bigSmall" /></td>
            <td class="info-td-o"><OddEven :value="metadata.oddEven" /></td>
            <td class="info-td-o"><RedBlack :value="metadata.redBlack" /></td>
            <td class="info-td-o"><HighLow :value="metadata.highLow" /></td>
            
          </tr>
        </Pass>
      </tbody>
	  </table>
	</div>
</template>

<script>
import { calculateScore } from '@handlers/atomwar/result.js';
import PlayerBanker from '@components/content/result/player-banker.vue';
import BigSmall from '@components/content/result/big-small.vue';
import OddEven from '@components/content/result/odd-even.vue';
import RedBlack from '@components/content/result/red-black.vue';
import HighLow from '@components/content/result/high-low.vue';
import Season from '@components/content/result/season.vue';

const Pass = {
  render() {
    return this.$scopedSlots.default(this.$attrs)
  }
}

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    Pass, PlayerBanker, BigSmall, OddEven, RedBlack, HighLow, Season,
  },
  props: {
    id: Number,
    endAt: String,
    data: Array,
  },
  data() {
    return {
      drawtype: '0',
    }
  },
  methods: {
    getDataDetail: function(column){
      if(column.resultRaw === undefined){
        return {};
      }
      const score = calculateScore(column);
      // console.log('score', score);
      return score;
    },
    selectFilter(event) {
      this.drawtype = event;
    },
  }
}
</script>

